import { render } from "./ErrorSection.vue?vue&type=template&id=6dbac967&scoped=true"
import script from "./ErrorSection.vue?vue&type=script&lang=js"
export * from "./ErrorSection.vue?vue&type=script&lang=js"

import "./ErrorSection.vue?vue&type=style&index=0&id=6dbac967&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dbac967"]])

export default __exports__